"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/yoga_retreat_ubud.png",
  alt: "Serene yoga retreat session in our open-air bamboo hall surrounded by nature"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/kids_party_ubud.png",
  alt: "Vibrant and creative kids' birthday party setup at Kilig Klub workshop space"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/craft_workshop_bali.png",
  alt: "Local artisan leading a craft workshop in our sun-drenched creative studio"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/corporate_event_bamboo.png",
  alt: "Professional corporate gathering in the majestic Bulwagan Bamboo Hall"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/private_celebration_dining.png",
  alt: "Intimate birthday celebration featuring warm lighting and organic decor"
}];
export default function CelebrationGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="42443" id="workshop-gallery" className="relative w-full bg-background text-foreground pt-20 pb-10 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className={cn("mb-12 text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl md:text-5xl font-sans font-bold text-primary mb-6">
            Creative Gatherings & Workshops
          </h2>
          <p className="text-secondary max-w-2xl mx-auto text-lg">
            From intimate craft workshops to vibrant kids' parties and soul-nourishing yoga retreats in the heart of Peliatan.
          </p>
        </div>

        {}
        <div ref={ref} className={cn("relative mx-auto max-w-5xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[20px]")}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {galleryImages.map((image, index) => <CarouselItem key={index} data-index={index} className="pl-4 md:basis-1/2 lg:basis-2/3">
                  <div className="group relative aspect-video overflow-hidden rounded-xl bg-muted shadow-md">
                    <img src={image.src} alt={image.alt} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" />
                    {}
                    <div className="absolute inset-0 bg-black/5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            {}
            <div className="hidden md:block">
              <CarouselPrevious className="border-primary text-primary hover:bg-primary hover:text-primary-foreground border-2 h-12 w-12 -left-16 transition-colors duration-300" variant="outline" />
              <CarouselNext className="border-primary text-primary hover:bg-primary hover:text-primary-foreground border-2 h-12 w-12 -right-16 transition-colors duration-300" variant="outline" />
            </div>
            
            {}
            <div className="flex justify-center gap-4 mt-8 md:hidden">
              <CarouselPrevious className="static translate-y-0 border-primary text-primary hover:bg-primary hover:text-primary-foreground border-2 h-10 w-10" variant="outline" />
              <CarouselNext className="static translate-y-0 border-primary text-primary hover:bg-primary hover:text-primary-foreground border-2 h-10 w-10" variant="outline" />
            </div>
          </Carousel>
        </div>
      </div>

      {}
      <div className="container mx-auto px-4 md:px-6 mt-20">
        <Separator className="bg-border" />
      </div>
    </section>;
}